import moment from 'moment';
import * as yup from 'yup';
const { yupResolver } = require('@hookform/resolvers/yup');

export const ELegacySurveyType = [
  { label: 'ทั้งหมด', value: 'all' },
  { label: 'เฉพาะนักธุรกิจ', value: 'Distributor' },
  { label: 'เฉพาะ VIP', value: 'Member' },
];

export const legacySurveyFormDefaultValues = {
  title: '',
  description: '',
  imageUrl: '',
  startDate: moment(),
  endDate: moment(),
  display: true,
  memberType: 'all',
};

export const legacySurveyFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      title: yup.string().required('กรุณากรอกข้อมูล'),
      imageUrl: yup.string().required('กรุณากรอกข้อมูล'),
      display: yup.boolean().defined(),
      startDate: yup.string().required('กรุณากรอกข้อมูล'),
      endDate: yup.string().required('กรุณากรอกข้อมูล'),
      memberType: yup.string().required('กรุณากรอกข้อมูล'),
    })
  );
};

export const ELegacySurveyQuestionType = [
  { label: 'เลือกคำตอบ', value: 'select' },
  { label: 'บรรยายคำตอบ', value: 'text' },
];

export const legacySurveyQuestionFormDefaultValues = {
  question: '',
  imageUrl: '',
  display: true,
  type: 'select',
  answers: [
    {
      imageUrl: '',
      answer: '',
    },
    {
      imageUrl: '',
      answer: '',
    },
    {
      imageUrl: '',
      answer: '',
    },
  ],
  required: true,
};

export const legacySurveyQuestionFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      question: yup.string().required('กรุณากรอกข้อมูล'),
      imageUrl: yup.string().defined('กรุณากรอกข้อมูล'),
      display: yup.boolean().defined(),
      answers: yup.array().min(1).required('กรุณากรอกข้อมูล'),
      type: yup.string().required('กรุณากรอกข้อมูล'),
      required: yup.boolean().defined(),
    })
  );
};
